/* eslint-disable no-undef */
import React, {Fragment, useContext, useEffect, useState} from "react";
import {_O} from "../../../modules/utils";
import {closeLayerFn, openLayerFn} from "../../Layout";

export const ExistIdLayer = (props) => {

    const {priv, dupList, type} = props;
    const [account, setAccount] = useState({"userId": "", "signUpChannel": ""});

    const returnToLogin = (type) => {
        if (account.signUpChannel === "000") {
            closeLayerFn($("#existLayer"));
            if (type === "REG") {
                $("input[name='email']").val(account.userId);
            } else {
                _O.Open('/membership/login/0/' + account.userId);
            }
        } else {
            closeLayerFn($("#existLayer"))
            _O.Open('/membership/login');
        }
    }

    return (
        <div className="blacklayer-container alert-layer-exist" id="existLayer">
            <div className="bl-blind"/>
            <div className="in-layerarea nobtn">

                <div
                    className={priv === undefined
                        ? "blgrn-box vertical"
                        : "blgrn-box vertical " + priv}>
                    <div className="save-question-box">
                        <span className="utt">
                            <p
                                style={{
                                    fontSize: "14px",
                                    textAlign: "left",
                                    marginBottom: "20px"
                                }}>
                                이미 가입된 계정이 있습니다.
                            </p>

                            <div
                                style={{
                                    border: "1px solid #fff",
                                    paddingTop: "10px"
                                }}>
                                {
                                    dupList && dupList.map((list, i) => (
                                        <ExistIdList
                                            setAccount={setAccount}
                                            userId={list.userId}
                                            signUpChannel={list.signUpChannel}
                                            since={list.cDate}
                                            key={"dupList" + i}/>
                                    ))
                                }
                            </div>
                        </span>
                    </div>

                    <div className="tbns-area">
                        <a className="btn-round wht" onClick={() => returnToLogin(type)}>확인</a>
                    </div>
                </div>

            </div>
        </div>
    );
}

const ExistIdList = (props) => {
    const {setAccount, userId, signUpChannel, since} = props;
    return (
        <div style={{
                marginBottom: "10px"
            }}>
            {
                (signUpChannel === "000") && <ExistListLabel
                        userId={userId}
                        signUpChannel={signUpChannel}
                        setAccount={setAccount}/>
            }
            <div>
                {/* <ExistListP text={userId} /> */}

                {signUpChannel === "000" && <ExistListP text={userId}/>}
                {signUpChannel === "500" && <ExistListP text={"병원인증번호가입"}/>}
                {signUpChannel === "100" && <ExistListP text={"SNS가입(네이버)"}/>}
                {signUpChannel === "400" && <ExistListP text={"SNS가입(카카오톡)"}/>}
                {signUpChannel === "600" && <ExistListP text={"SNS가입(애플)"}/>}

                <ExistListP text={"가입:" + since}/>
            </div>
        </div>
    );
}

export const ExistListLabel = (props) => {
    const {userId, signUpChannel, setAccount} = props;
    return (
        <label
            style={{
                position: "absolute",
                left: "60px"
            }}>
            <input
                type="radio"
                name="radio01"
                onClick={() => setAccount({"userId": userId, "signUpChannel": signUpChannel})}/>
        </label>
    );
}

export const ExistListP = (props) => {
    const {text} = props;
    return (
        <p style={{
                fontSize: "14px"
            }}>
            {text}
        </p>
    )
}